import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { reduxForm, FieldArray, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import ImageUploadComponent from '../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommomImageDisplay';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';
import FieldArrayComponent from '../../CommonFields/FieldArrayComponent';

import { whyHostUploadDir } from '../../../config';
import submit from './submit';
import validate from './validate';
import messages from '../../../locale/jsonMessages';
import { photosShow } from '../../../helpers/photosShow';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import defaultPic from '/public/AdminIcons/default.svg';
import deleteIcon from '/public/AdminIcons/dlt.png';
import { AddPlusSvg } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { formatLocaleData } from '../../../helpers/formatLocale';

import cs from '../../../components/commonStyle.css';
import s from './WhyHostForm.css';

class WhyHostForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    title: PropTypes.string.isRequired,
  };

  renderDocument = ({ fields, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    const { whyHostUploaderLoading, dataList } = this.props;
    let path = photosShow(whyHostUploadDir);

    return (
      <div className='twoColumnGrid'>
        {fields && fields.length > 0 && fields.map((document, index) => {
          let fieldLength = fields.length - 1;
          let image = fields.get(index) && fields.get(index).imageName;

          const selectedLanguage = dataList?.[index]?.dynamicWhyHost;

          const success = async (file, fromServer) => {
            const { change, demoRestriction } = this.props;
            const images = `${document}.imageName`;
            const fileName = fromServer.file.filename;
            const isRestrict = await demoRestriction({});
            if (isRestrict) return;
            await change(images, fileName);
          };

          return (
            <div key={index}>
              <div className={cx(s.sectionBorder, 'oneColumnGrid')}>

                <div className='siteAdminDropZoneWrapper'>
                  <label className={cx('commonLabelText', cs.spaceBottom3)}>
                    {formatMessage(messages.imageLabel)}
                  </label>
                  <div className='positionRelative'>
                    <CommonImageDisplay
                      loader={whyHostUploaderLoading['whyHostUploaderLoading' + index]}
                      image={image ? path + image : defaultPic}
                      isDefaultPic={image ? false : true}
                      isDelete={false}
                    />
                    {fields && fields.length > 1 &&
                      <div className={cx(cs.trashIconNew, 'trashIconRTL')}>
                        <img
                          src={deleteIcon}
                          onClick={() => fields.remove(index)}
                          className={s.removeIcon}
                        />
                      </div>
                    }
                  </div>
                  <ImageUploadComponent
                    subText={formatMessage(messages.uploadSizedLabel)}
                    defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
                    componentConfig={{
                      iconFiletypes: ['.jpg', '.png', '.jpeg'],
                      multiple: false,
                      showFiletypeIcon: false,
                      postUrl: '/uploadWhyHost'
                    }}
                    loaderName={`whyHostUploaderLoading${index}`}
                    success={success}
                    className={cs.spaceTop3}
                  />
                </div>

                <FieldArray
                  name={`${document}.dynamicWhyHost`}
                  component={FieldArrayComponent}
                  activesFields={['language', 'title', 'buttonLabel']}
                  filedName="dynamicWhyHost"
                  selectedLanguage={selectedLanguage}
                />

              </div>

              {fieldLength == index &&
                <div className={cx(s.spaceTop3, 'singleBtnFlexEnd')}>
                  <Button
                    variant="primary"
                    onClick={() => fields.push({
                      imageName: null,
                      title: null,
                      buttonLabel: null,
                      dynamicWhyHost: [{ language: 'en', title: '', buttonLabel: '' }]
                    })}
                    className={cx(cs.linkBtnPrimaryStyle, cs.dFlex, cs.gap4)}
                  >
                    <AddPlusSvg />
                    {formatMessage(messages.addLabel)}
                  </Button>
                </div>
              }
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        <div className={cx('tooltipFlex', cs.spaceBottom4, cs.alignCenter)}>
          <h1 className={cx('siteAdminHeading', cs.noMargin)}>
            <FormattedMessage {...messages.whyHostPage} />
          </h1>
          <ToolTipSection
            label={formatMessage(messages.whyHostTooltipText)}
            tooltipIconClass={cx(cs.positionRelative, cs.top3)}
          />
        </div>
        <form onSubmit={handleSubmit(submit)}>
          <FieldArray
            name="dataList"
            rerenderOnEveryChange={true}
            component={this.renderDocument}
          />
          <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
            <Button className={cx(cs.btnPrimary)} type="submit" disabled={submitting}>
              <FormattedMessage {...messages.save} />
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

WhyHostForm = reduxForm({
  form: 'WhyHostForm',
  validate
})(WhyHostForm);

const selector = formValueSelector('WhyHostForm');

const mapState = (state) => ({
  dataList: selector(state, 'dataList'),
  whyHostUploaderLoading: state.loader,
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = {
  change,
  demoRestriction
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(WhyHostForm)));